import { PaginationContextValue } from 'src/providers/PaginationProvider';

export const getPaginatedData = <TArrayItem>(
  data: TArrayItem[],
  pagination: PaginationContextValue,
): TArrayItem[] => {
  const minIndex = pagination.rowsPerPage * pagination.page;
  const maxIndex = pagination.rowsPerPage * (pagination.page + 1);

  return data.filter((_item, index) => {
    return index >= minIndex && index < maxIndex;
  });
};
